import { css } from 'linaria';
import { createAdaptiveComponent } from './create-adaptive-component';

const fromTablet = css`
	display: none;

	@media (--from-tablet) {
		display: initial;
	}
`;

const atTablet = css`
	display: none;

	@media (--only-tablet) {
		display: initial;
	}
`;

const toTablet = css`
	display: none;

	@media (--only-mobile) {
		display: initial;
	}

	@media (--only-tablet) {
		display: initial;
	}
`;

export const FromTablet = createAdaptiveComponent({
	displayName: 'FromTablet',
	ssrClassName: fromTablet,
});

export const AtTablet = createAdaptiveComponent({
	displayName: 'AtTablet',
	ssrClassName: atTablet,
});

export const ToTablet = createAdaptiveComponent({
	displayName: 'ToTablet',
	ssrClassName: toTablet,
});
